import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';
import Slider from "react-slick";

import Component from "components/component";
import {
  isSelectable,
  shouldOptionRowUpdate,
  updateSliderOnOpenToggle,
  getDisplayPriceOfSizeSelection
} from "lib/helpers";

import SizeOption from "./size-option";
import SizeOptionMobile from "./size-option-mobile";
import SizeOptionSelection from "./size-option-selection";
import SelectionPrompt from "./selection-prompt";
import CustomSizeInput from "./custom-size-input";

const settings = {
  speed: 500,
  dots: false,
  arrows: false,
  infinite: false,
  draggable: true,
  focusOnSelect: false,
  slidesToShow: 4,
  swipeToSlide: true,
  centerMode: false
};

export default class SizeOptionRow extends Component {
  static propTypes = {
    optionType: ImmutablePropTypes.map.isRequired,
    optionValues: ImmutablePropTypes.map.isRequired,
    selection: ImmutablePropTypes.map,
    handleClick: PropTypes.func.isRequired,
    customValueChanged: PropTypes.func.isRequired,
    selections: ImmutablePropTypes.map,
    optionValueRestrictions: ImmutablePropTypes.map,
    productType: PropTypes.string.isRequired,
    quantityCount: PropTypes.number.isRequired,
    selectedVariant: ImmutablePropTypes.map,
  };

  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  shouldComponentUpdate(newProps, newState) {
    return shouldOptionRowUpdate(newProps, newState, this);
  }

  toggleOpen = e => {
    if (e) e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };

  UNSAFE_componentDidUpdate(oldProps, oldState) {
    updateSliderOnOpenToggle(oldState, this);
  }

  render() {
    if (this.props.optionValues.isEmpty()) return null;

    const { isOpen } = this.state;
    const {
      optionType,
      optionValues,
      selection,
      handleClick,
      customValueChanged,
      selections,
      optionValueRestrictions,
      productType,
      quantityCount,
      selectedVariant,
      userRole,
    } = this.props;

    const optionName = optionType.get("displayName");
    const optionTypeId = optionType.get("id");
    const toggleClass = isOpen ? "toggle-row open" : "toggle-row";
    const selectionIsPresent = !!selection;
    let selectionId,
      selectionName,
      selectionUpchargeAmount,
      selectionCustomValue,
      isCustom,
      selectionCustomMax;
    let selectionIndex = 0;

    if (selectionIsPresent) {
      selectionId = selection.get("id");
      selectionName = selection.get("displayName");
      selectionUpchargeAmount = selection.get("upchargeAmount");
      selectionCustomValue = selection.get("customValue");
      selectionCustomMax = selection.get("customMax");
      isCustom = selection.get("isCustom");
      selectionIndex = optionValues
        .valueSeq()
        .findIndex(ov => ov.get("id") === selectionId);
    }

    const onCustomChange = value => {
      customValueChanged(optionTypeId, selectionId, value);
    };

    const hasSofaCustomizationNotice =
      SHOW_CUSTOMIZATION_NOTE && productType === "sofas" && userRole === 'trade_user';

    return (
      <div>
        <div className="product-options-title-row desktop-only">
          <p className="lined-title">
            <span>{optionName}</span>
          </p>
        </div>

        <div className="product-options-row option-columns two-columns">
          <div className="product-options-wrapper-mobile mobile-only">
            <a href="#" className={toggleClass} onClick={this.toggleOpen} />

            {!isOpen && !selectionIsPresent && (
              <div>
                <p className="option-name">{optionName}</p>
                <SelectionPrompt name={selectionName} />
              </div>
            )}

            {!isOpen && selectionIsPresent && (
              <SizeOptionSelection
                customValue={selectionCustomValue}
                isCustom={isCustom}
                optionName={optionName}
                selectionName={selectionName}
                quantityCount={quantityCount}
                displayPrice={(() => {
                  const sizeSelection = selections.find(ov => {
                    return (
                      SIZE_OPTION_NAMES.indexOf(ov.get("optionType")) > -1
                    );
                  });


                  if (userRole !== 'trade_user') {
                    const listPrice = selectedVariant.get('displayListPrice');

                    return listPrice;
                  }

                  return getDisplayPriceOfSizeSelection(
                    sizeSelection,
                    selectedVariant
                  );
                })()}
              />
            )}

            <div style={{ display: isOpen ? "block" : "none" }}>
              <p className="option-name">{optionName}</p>

              <div className="product-options-slider-wrapper">
                <Slider {...settings} slickGoTo={selectionIndex} ref="slider">
                  {optionValues
                    .valueSeq()
                    .filter((optionValue) => {
                      if (userRole !== 'trade_user') {
                        return !optionValue.get('isCustom');
                      }

                      return true;
                    })
                    .map((optionValue, key) => {
                      const id = optionValue.get("id");
                      const selectable = isSelectable(
                        selections,
                        optionValueRestrictions,
                        id
                      );

                      return (
                        <div key={id}>
                          <SizeOptionMobile
                            optionValue={optionValue}
                            isSelected={selectionId === id}
                            handleClick={handleClick}
                            customValueChanged={customValueChanged}
                            customValue={selectionCustomValue}
                            selectable={selectable}
                            inSlider
                          />
                        </div>
                      );
                    }
                  )}
                </Slider>

                {isCustom && (
                  <div className="custom-size-input-mobile mobile-only">
                    <CustomSizeInput
                      value={selectionCustomValue}
                      onChange={onCustomChange}
                      displayName={selectionName}
                      selectionId={selectionId}
                      upchargeAmount={selectionUpchargeAmount}
                      max={selectionCustomMax}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="desktop-only">
            <div className="options-container size-options">
              {optionValues.valueSeq().map((optionValue, key) => {
                const id = optionValue.get("id");
                const selectable = isSelectable(
                  selections,
                  optionValueRestrictions,
                  id
                );

                return (
                  <SizeOption
                    key={id}
                    optionValue={optionValue}
                    isSelected={selectionId === id}
                    handleClick={handleClick}
                    customValueChanged={customValueChanged}
                    customValue={selectionCustomValue}
                    selectable={selectable}
                    userRole={userRole}
                    productType={productType}
                  />
                );
              })}
            </div>
          </div>

          {hasSofaCustomizationNotice && (
            <div className="customization-notice-wrapper desktop-only">
              <p className="customization-notice-headline">
                Customization Note
              </p>
              <p className="customization-notice-subheader">
                You may order this sofa as a sectional. Please provide your
                details in the Custom Request field at the bottom of the page or{" "}
                <a href="/contact" className="customization-notice-link">
                  contact us
                </a>.
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}
